<template>
  <div class="ranking-export-actions" data-testid="ranking-export-actions">
    <a
      :class="['export-link', { 'export-link--disabled': isDisabled }]"
      data-testid="export-image-link"
      @click.prevent="!isDisabled && $emit('export-image')"
    >
      {{ $t('save_as_image') }}
    </a>
    <span class="export-separator">/</span>
    <a
      :class="['export-link', { 'export-link--disabled': isDisabled }]"
      data-testid="export-csv-link"
      @click.prevent="!isDisabled && $emit('export-csv')"
    >
      {{ $t('save_as_csv') }}
    </a>
  </div>
</template>

<i18n lang="yaml">
ja:
  save_as_image: 画像で保存
  save_as_csv: CSVで保存

en:
  save_as_image: Save as Image
  save_as_csv: Save as CSV
</i18n>

<script>
export default {
  name: 'RankingExportActions',
  props: {
    exporting: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    isDisabled() {
      return this.exporting || this.disabled;
    },
  },
};
</script>

<style scoped>
.ranking-export-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 16px;
  border-top: 1px solid #e0e0e0;
}

.export-link {
  color: #1976d2;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
}

.export-link:hover {
  text-decoration: underline;
}

.export-link--disabled {
  color: #9e9e9e;
  cursor: default;
  pointer-events: none;
}

.export-separator {
  margin: 0 8px;
  color: #9e9e9e;
}
</style>
